document.addEventListener('DOMContentLoaded', function () {
  const inputs = document.querySelectorAll('input[type="text"]');

  function toHalfWidth(value) {
    return value
      .replace(/[！-～]/g, function (char) {
        return String.fromCharCode(char.charCodeAt(0) - 0xFEE0);
      })
      .replace(/　/g, ' ');
  }

  inputs.forEach(function (input) {
    input.addEventListener('input', function () {
      const converted = toHalfWidth(this.value);
      if (this.value !== converted) {
        this.value = converted;
      }
    });

    input.addEventListener('change', function () {
      this.value = toHalfWidth(this.value);
    });
  });
});